import "./NewBrokerTable.css";

const NewBrokerTable = ({ tableData }) => {
  return (
    <table className="broker-table">
      <thead>
        <tr>
          <th>Y-tunnus</th>
          <th>Välitystoiminnan muoto</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{tableData.businessId}</td>
          <td>{tableData.brokeringForm}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default NewBrokerTable;
